import { useEffect, useState } from "react";
import axiosInstance from "../../interceptor/axiosInstance";
 
const EditDialog = ({ open, onClose, onSave, orgId, chatId, messageId }) => {
 
    const [question, setQuestion] = useState("");
    const [answer, setAnswer] = useState("");
    const [error, setError] = useState(null);
    const [isModified, setIsModified] = useState(false);

    useEffect(()=> {
      if(open){
        const fetchData = async () => {
          try {
            const res = await axiosInstance.get(`/org/debug-log/qna/${messageId}`)
            const item = res.data[0]; // get first element
              if (item) {
                setQuestion(item.question || "");
                setAnswer(item.answer || "");
                setIsModified(item.fromFeedback || false);
              }
          } catch(err) {
            console.error("Failed to load message details", err);
          }
        }
        fetchData();
      }
  }, [open, messageId]);

  if (!open) return null;

  const handleSave = async () => {
     if (!question.trim() || !answer.trim()) {
      setError("Both Question and Answer are required.");
      return;
    }
    setError("");
    try {
      const payload = {
        orgId,
        chatId,
        messageId,
        question,
        answer
      };
  
      await axiosInstance.post(
        "org/store-string-vector",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
 
      onClose(); // close dialog
      if (onSave) {
        onSave();
      }
    } catch (error) {
      console.error("Error saving:", error);
      alert("Failed to save knowledge base entry.");
    }
  };
  

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0, 0, 0, 0.2)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "20px",
          borderRadius: "8px",
          width: "70vw",
          height: "70vh",
          display: "flex",
          flexDirection: "column",   // stack items vertically
        }}
      >
        <div style={{ flex: 1, overflow: "auto" }}>
          <h4 style={{ color: "#b30000" }}>Edit Knowledge Base</h4>
           <div style={{display: "flex", justifyContent: "space-between", marginBottom: "0px"}}>
             <label style={{ fontSize: "14px", fontWeight: "bold", marginTop: "10px" }}>
            Question
          </label>
          {isModified && (
            <p style={{ fontSize: "12px", color: "green", marginTop: "4px" }}>
              ✔ This answer was modified
            </p>
          )} 
            </div>        
         
          <textarea
            placeholder="Type the best possible question users might ask..."
            style={{
              width: "100%",
              height: "15%",
              marginTop: "2px",
              borderRadius: "5px",
              resize: "vertical",
            }}
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            required
          />
          <label
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              marginTop: "10px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            Answer
          </label>
          <textarea
            required
            placeholder="Provide a clear and concise answer for the question..."
            style={{
              width: "100%",
              height: "40%",
              marginTop: "2px",
              borderRadius: "5px",
              resize: "vertical",
            }}
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
          />
          {error && <p style={{ color: "red", marginLeft: "4px", fontSize: "11px" }}>{error}</p>}
          <div
            style={{
              position: "sticky",
              bottom: 0,
              background: "#fff",
              paddingTop: "25px",
              textAlign: "right",
              borderTop: "1px solid #eee", // separator line
            }}
          >
            <button
              onClick={onClose}
              style={{
                marginRight: "10px",
                padding: "6px 12px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              style={{
                padding: "6px 12px",
                background: "#b30000",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditDialog;


